/** Triggers a browser download of a same-origin URL or data URL. */
export function downloadFile(url: string, fileName: string): void {
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
}

/** File extension of a URL path (`/files/x/render.webp` -> `webp`), or the fallback. */
export function extensionOf(url: string, fallback = 'png'): string {
  if (url.startsWith('data:')) return url.slice(11, url.indexOf(';')).replace('jpeg', 'jpg') || fallback;
  const name = url.split(/[?#]/)[0].split('/').pop() ?? '';
  const dot = name.lastIndexOf('.');
  return dot > 0 ? name.slice(dot + 1) : fallback;
}
